export default __webpack_public_path__ + "static/pistachiobarfi-50008ffa822736a0f067e0fa3a42f023.png";